<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="illustration"></a>
<a id="page_viii"></a>
<h2 class="chaptertitle1">ILLUSTRATIONS</h2>
<p class="blockquote" id="illus_p1">
<a href="#/part1#part1">
<i>The Morning of the Monkey</i>
</a>
</p>
<p class="body-text" id="illus_p2">
<a href="#/chap1#UF1-1">Judge Dee saw that the gibbon was watching him</a>
</p>
<p class="body-text" id="illus_p3">
<a href="#/chap1#UF1-2">‘I am not yet through with you, Mr Leng!’</a>
</p>
<p class="body-text" id="illus_p4">
<a href="#/chap1#UF1-3">‘It's a very private matter,’ Tao Gan said</a>
</p>
<p class="body-text" id="illus_p5">
<a href="#/chap1#UF1-4">‘Well,’ she said, ‘I have done nothing wrong’</a>
</p>
<p class="extra-indent" id="illus_p6"> </p>
<p class="blockquote" id="illus_p7">
<span href="#/part2#part2" title="Link target outside of Sample">
<i>The Night of the Tiger</i>
</span>
</p>
<p class="body-text" id="illus_p8">
<span href="#/chap2#UF2-1" title="Link target outside of Sample">Judge Dee caught the spear on his sword</span>
</p>
<p class="body-text" id="illus_p9">
<span href="#/chap2#UF2-3" title="Link target outside of Sample">He pulled the silk strings in succession</span>
</p>
<p class="body-text" id="illus_p10">
<span href="#/chap2#UF2-4" title="Link target outside of Sample">Suddenly the judge had the feeling that he was not alone</span>
</p>
<p class="body-text" id="illus_p11">
<span href="#/chap2#UF2-5" title="Link target outside of Sample">‘I grabbed her and shouted at her to stop…’</span>
</p>
<p class="body-text" id="illus_p14">
<span href="#/chap2#UF2-2" title="Link target outside of Sample">A sketchmap of the flooded area</span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustration.vue?34160bab